// fr strings for messages/paywall.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const paywall: Dict = {
  "paywall.hl.unlimitedCovers": "Covers illimitées",
  "paywall.hl.voices": "Plus de 93 000 voix",
  "paywall.hl.downloads": "Téléchargements",
  "paywall.hl.duetsTts": "Duos et synthèse vocale",
  "paywall.hl.trainVoices": "Entraîne tes voix",
  "paywall.hl.hdVideos": "Vidéos en 1080p",
  "paywall.hl.videoCoins": "50 pièces vidéo par mois",
  "paywall.hl.marbleLyric": "Vidéos Marble Run et avec paroles",
  "paywall.hl.priority": "Traitement prioritaire",
  "paywall.hl.unlimitedCoins": "Pièces vidéo illimitées",
  "paywall.hl.apiCredits": "$25 de crédits API par mois",
  "paywall.hl.everythingCreator": "Tout ce qu'offre Creator",
  "paywall.hl.thisCover": "Cette cover, tout de suite",

  "paywall.reason.unlock.title": "Débloque ta cover",
  "paywall.reason.unlock.body":
    "Ta voix et ton audio sont prêts. Abonne-toi et ta cover se lance tout de suite, prête en une minute environ. Ensuite, fais-en autant que tu veux.",
  "paywall.reason.create.title": "Ta cover est prête à être créée",
  "paywall.reason.create.body":
    "Ton audio et ta voix sont prêts. Choisis un abonnement pour la créer, puis fais autant de covers que tu veux.",
  "paywall.reason.browse.title": "Fais des covers avec n'importe quelle voix",
  "paywall.reason.browse.body":
    "Covers illimitées, téléchargements et plus de 93 000 voix. Annule quand tu veux.",
  "paywall.reason.credits.title": "Tu as utilisé tous tes crédits",
  "paywall.reason.credits.body":
    "Ta prochaine cover t'attend. Basic est illimité, tu n'auras plus jamais à compter tes crédits.",
  "paywall.reason.words.title": "Fais dire tes mots à la voix",
  "paywall.reason.words.body":
    "Écris un texte ou décris une chanson, et la voix le chante ou le dit. Inclus dès Basic.",
  "paywall.reason.video.title": "Transforme-la en vidéo",
  "paywall.reason.video.body":
    "Vidéos Marble Run et avec paroles, prêtes pour TikTok et Reels. Creator inclut 50 pièces vidéo chaque mois.",
  "paywall.reason.resume.title": "Reprends là où tu t'étais arrêté",
  "paywall.reason.resume.body":
    "Ton abonnement est enregistré. Termine le paiement, puis fais autant de covers que tu veux.",
  "paywall.reason.train.title": "Crée une voix que personne d'autre n'a",
  "paywall.reason.train.body":
    "Entraîne tes propres voix à partir de quelques extraits et utilise-les dans n'importe quelle cover. Illimité avec Creator.",

  "paywall.cta.unlockFor": "Débloquer ma cover pour {price}",
  "paywall.cta.keepGoingFor": "Continuer pour {price}",
  "paywall.cta.backToCreatorFor": "Reviens sur Creator pour {price}",
  "paywall.cta.backFor": "Reviens pour {price}",
  "paywall.cta.startFor": "Commence pour {price}",
  "paywall.cta.startPlanFor": "Commence {plan} pour {price}",

  "paywall.renew.welcome":
    "{price} par mois tant que tu restes abonné. Renouvellement mensuel jusqu'à ce que tu annules.",
  "paywall.renew.then":
    "Puis {price} par mois. Renouvellement mensuel jusqu'à ce que tu annules.",
  "paywall.renew.yearly":
    "{price} facturés aujourd'hui pour 12 mois. Renouvellement annuel jusqu'à ce que tu annules.",

  "paywall.toast.updated": "Ton abonnement a été mis à jour !",
  "paywall.toast.error": "Une erreur est survenue, réessaie.",
  "paywall.welcomeBack": "CONTENT DE TE REVOIR",
  "paywall.priceMonth": "{price} par mois",

  "paywall.welcome.offerCreator": "Creator pour {price} par mois",
  "paywall.welcome.card":
    "Ton abonnement s'est arrêté parce qu'un paiement n'est pas passé, pas parce que tu es parti. Reprends là où tu t'étais arrêté pour {offer}.",
  "paywall.welcome.price":
    "Tu nous as dit que c'était trop cher, alors voici moins cher : {offer} au lieu de {was}, tant que tu restes abonné.",
  "paywall.welcome.broken":
    "Tu nous as dit que quelque chose ne marchait pas. La semaine dernière, {n} covers sur 100 sont sorties sans problème. Reviens pour {offer}.",
  "paywall.welcome.secretCreator":
    "Creator pour {price} par mois, avec un abonnement qu'on n'affiche nulle part. Il reste à toi tant que tu es abonné.",
  "paywall.welcome.secret":
    "Tout ce que tu avais, pour {price} par mois, avec un abonnement qu'on n'affiche nulle part. Il reste à toi tant que tu es abonné.",
  "paywall.welcome.coversHere": "Tes {n} covers sont toujours là",
  "paywall.welcome.coverHere": "Ta cover est toujours là",
  "paywall.welcome.makeAgain": "Refaire des covers",

  "paywall.ended.today": "Ton abonnement s'est terminé aujourd'hui",
  "paywall.ended.yesterday": "Ton abonnement s'est terminé hier",
  "paywall.ended.days": "Ton abonnement s'est terminé il y a {n} jours",
  "paywall.ended.months": "Ton abonnement s'est terminé il y a {n} mois",

  "paywall.more": "de plus",
  "paywall.recommended": "RECOMMANDÉ",
  "paywall.perMonth": "par mois",
  "paywall.perMonthStay": "par mois, tant que tu restes abonné",
  "paywall.firstMonth": "premier mois",
  "paywall.today": "aujourd'hui",
  "paywall.heldFor": "Gardée pendant {time}",
  "paywall.coverReady": "TA COVER EST PRÊTE À ÊTRE CRÉÉE",
  "paywall.coverSetUp": "Ton audio et ta voix sont prêts",
  "paywall.coversToday": "{n} covers créées aujourd'hui sur Jammable",
  "paywall.coversTodayShort": "{n} covers créées aujourd'hui",
  "paywall.pickPlanUnlock": "Choisis un abonnement pour la débloquer",
  "paywall.pickPlan": "Choisis un abonnement",
  "paywall.whatYouGet": "CE QUE TU OBTIENS AVEC {plan}",
  "paywall.secure": "Paiement sécurisé avec Stripe · annule quand tu veux",
  "paywall.topPlan": "Tu as déjà notre meilleur abonnement",
  "paywall.managePlan": "Gérer ton abonnement",
  "paywall.changePlan": "Changer d'abonnement",
  "paywall.planYearly": "{plan}, annuel",
  "paywall.planMonthly": "Abonnement {plan}",
  "paywall.billedYearly": "Facturé à l'année",
  "paywall.pay": "Payer",
  "paywall.payUnlock": "Payer et débloquer",
  "paywall.checkoutLoading": "Préparation de ton paiement",

  "paywall.leave.title": "Partir sans ta cover ?",
  "paywall.leave.oneStep": "Tu es à une étape.",
  "paywall.leave.audioIn": "Ton audio est importé",
  "paywall.leave.voiceReady": "La voix de {names} est prête à la chanter",
  "paywall.leave.voicesReady": "Les voix de {names} sont prêtes à la chanter",
  "paywall.leave.voicePicked": "Ta voix est choisie",
  "paywall.leave.makeStep": "Créer la cover : une minute environ",
  "paywall.leave.gets": "EN DÉBLOQUANT, TU OBTIENS",
  "paywall.leave.held":
    "Elle est gardée pendant {time}. Ensuite, elle est supprimée et tu devras la refaire.",
  "paywall.unlockMyCover": "Débloquer ma cover",
  "paywall.leaveAnyway": "Partir quand même",

  "paywall.gift.wrapping": "On t'emballe quelque chose…",
  "paywall.gift.beforeYouGo": "AVANT DE PARTIR",
  "paywall.gift.saved": "On t'a gardé un cadeau",
  "paywall.gift.openToSee": "Ouvre-le pour découvrir ce que c'est.",
  "paywall.gift.opening": "Ouverture…",
  "paywall.gift.open": "Ouvrir mon cadeau",
  "paywall.gift.noThanks": "Non merci, partir",
  "paywall.gift.yours": "TON CADEAU",
  "paywall.gift.headline": "{plan} pour {price} par mois",
  "paywall.gift.body":
    "Covers illimitées avec toutes les voix, prix bloqué pendant 12 mois.",
  "paywall.gift.save": "ÉCONOMISE {pct} %",
  "paywall.perMo": "/mois",
  "paywall.gift.billedYearly": "{price} facturés à l'année",
  "paywall.gift.lockIn": "Bloque {price} par mois",
  "paywall.seeMonthly": "Voir les abonnements mensuels",

  "paywall.locked.step.upload": "Import de ton audio",
  "paywall.locked.step.match": "Préparation de la voix",
  "paywall.locked.step.mix": "Préparation du mix",
  "paywall.locked.yourAudio": "ton audio",
  "paywall.locked.yourAiSong": "ta chanson IA",
  "paywall.locked.yourWords": "tes mots",
  "paywall.locked.yourVoice": "Ta voix",
  "paywall.locked.startFailed": "Impossible de lancer la cover. Réessaie.",
  "paywall.locked.makeNow": "La créer maintenant",
  "paywall.unlock": "Débloquer",
  "paywall.locked.pctDone": "{pct} % terminé",
  "paywall.locked.gettingReady": "On prépare {names} pour {song}",
  "paywall.locked.done": "terminé",
  "paywall.locked.now": "en cours",
  "paywall.locked.expired": "Cette cover a expiré",
  "paywall.locked.expiredBody":
    "Les covers verrouillées sont gardées 48 heures. Refais-la en une minute.",
  "paywall.locked.makeAgain": "La refaire",
  "paywall.locked.readyToMake": "Prête à être créée",
  "paywall.locked.readyOne": "La voix IA de {names} est prête à chanter {song}",
  "paywall.locked.readyMany":
    "Les voix IA de {names} sont prêtes à chanter {song}",
  "paywall.locked.onPlan":
    "Tu as un abonnement, elle peut donc démarrer tout de suite. Ça prend une minute environ.",
  "paywall.locked.unlockBody":
    "Débloque-la et ta cover se lance tout de suite. Ça prend une minute environ, et ensuite elle est à toi : télécharge-la et partage-la.",
  "paywall.locked.change": "Changer la voix ou l'audio",
  "paywall.locked.notMade": "Cette cover n'a pas encore été créée",
  "paywall.locked.makeYourOwn":
    "Fais la tienne avec {names} en une minute environ.",
  "paywall.locked.makeCover": "Faire une cover",

  "paywall.video.unlock": "Débloque ta cover\net ta vidéo",
  "paywall.video.howItLooks": "Voici à quoi ressemblera ta vidéo",
  "paywall.video.drawing": "Préparation de ta vidéo",
  "paywall.video.aria": "{cta} : ta cover et sa vidéo",

  "paywall.return.firstMonth": "{price} ton premier mois",
  "paywall.return.waiting": "Ta cover de {title} t'attend",
  "paywall.return.savedWaiting": "Ta cover enregistrée t'attend",
  "paywall.return.trialReady": "Ton essai gratuit de 7 jours est prêt",
  "paywall.return.trialDetail":
    "Rien à payer aujourd'hui, puis {price} par mois. Annule quand tu veux.",
  "paywall.return.startTrial": "Commencer mon essai gratuit",
  "paywall.return.funds":
    "Ta banque indique que le solde de la carte est insuffisant.",
  "paywall.return.declined": "Ta banque a refusé le paiement.",
  "paywall.return.cardFailed": "Ta carte n'est pas passée",
  "paywall.return.cardDetail":
    "Ta carte n'est pas passée. Essaie Apple Pay, Google Pay ou une autre carte · {price}",
  "paywall.return.whyDetail":
    "{why} Essaie Apple Pay, Google Pay ou une autre carte · {price}",
  "paywall.return.tryAnother": "Essayer autrement",
  "paywall.return.confirm": "Ta banque demande une confirmation rapide",
  "paywall.return.confirmDetail": "Encore une étape et c'est bon · {price}",
  "paywall.return.finish": "Terminer le paiement",
  "paywall.return.planHere": "Ton abonnement {plan} est toujours là",
  "paywall.return.heldMore": "Gardée encore {time} · {price}",
  "paywall.return.thenRegular": "{price}, puis {regular}",
  "paywall.return.cancelAny": "{price}, annule quand tu veux",
  "paywall.return.pickUp": "Reprendre là où je m'étais arrêté",
  "paywall.return.cardStopped":
    "Ton abonnement s'est arrêté quand un paiement n'est pas passé",
  "paywall.return.comeBack": "Reviens sur Jammable",
  "paywall.return.pickUpFor": "Reprends là où tu t'étais arrêté pour {offer}.",
  "paywall.return.secretOffer":
    "Reviens pour {offer}, avec un abonnement qu'on n'affiche nulle part.",
  "paywall.return.hide": "Masquer",
};

export default paywall;
